module.exports = __webpack_public_path__ + "img/podium_5678.056c2727.jpg";